import { BrandId } from '~/api/api.declaration';
import { ApiService } from '~/service/service.api';
import { BrandImportItem } from '~/shared/dto/admin/brand.dto';
import { Model } from '~/shared/service/service.base';
import { ImportModel } from './model.import';

type BrandRowType = Omit<InstanceType<typeof BrandImportItem>, 'id'> & {
	brandId: BrandId;
};

@Model()
export class BrandImportModel extends ImportModel<BrandImportItem> {
	constructor(api: ApiService) {
		super(BrandImportItem, api.brandImport.bind(api));
	}

	getItemFromRow(row: BrandRowType): BrandImportItem {
		return {
			id: this.parseNumber(row.brandId) as BrandId,
			name: row.name,
			active: this.parseBoolean(row.active),
			dupe: this.parseBoolean(row.dupe),
			description: row.description,
			year: this.parseNumber(row.year) || undefined,
			country: row.country,
			synonyms: this.parseStringArray(row.synonyms),
			images: this.parseStringArray(row.images),
		};
	}

	hanldeClickDownloadTemplate = () => {
		const example: BrandRowType = {
			brandId: 42,
			name: 'Example Brand',
			active: true,
			dupe: false,
			description: 'A short description',
			images: ['image1.jpg', 'image2.jpg'],
			year: 1999,
			country: 'France',
			synonyms: ['Example', 'Sample'],
		};

		this.buildAndDownloadCSV('brand-import-template.csv', example);
	};
}
